import { lazy } from "react";

export const ResetPasswordAsync = lazy(() => import("./ResetPassword"));
